module.exports = __webpack_public_path__ + "static/img/banner.66e66ef1.png";